// angular
import { Component, effect, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
// components
import { ProjectCardComponent } from '@app/core/components/project-card/project-card.component';
import { ProjectCardSkeletonComponent } from '@app/core/components/project-card/project-card-skeleton/project-card-skeleton.component';
import { PaginationComponent } from '@app/core/components/pagination/pagination.component';
import { NoContentComponent } from '@app/core/components/no-content/no-content.component';
import { SortsBarComponent } from '@app/core/components/sorts-bar/sorts-bar.component';
// services
import { ProjectsService } from '../shared/services/projects.service';
// constants
import { projectsSortItems } from '../shared/constants/projects-sort-items';
// types
import { IProject } from '../shared/types/project.interface';

@Component({
  selector: 'pwj-projects-list',
  standalone: true,
  imports: [
    SortsBarComponent,
    ProjectCardComponent,
    ProjectCardSkeletonComponent,
    PaginationComponent,
    TranslateModule,
    NgxSkeletonLoaderModule,
    NoContentComponent,
  ],
  templateUrl: './projects-list.component.html',
  styleUrl: './projects-list.component.scss',
})
export class ProjectsListComponent implements OnInit {
  public projectsData: IProject[] = [];
  public allProjectsCount = 0;
  public isLoading = true;
  public readonly sortItems = projectsSortItems;

  private readonly _activatedRoute = inject(ActivatedRoute);
  private readonly _projectsService = inject(ProjectsService);

  constructor() {
    effect(() => {
      this.allProjectsCount = this._projectsService.projectsCount();
    });

    effect(() => {
      this.isLoading = this._projectsService.isProjectsLoading();
    });

    effect(() => {
      this.projectsData = this._projectsService.projectsList();
    });
  }

  ngOnInit(): void {
    this._activatedRoute.queryParams.subscribe(params => {
      const take = params['perPage'] || 6;
      const skip = params['page'] ? (Number(params['page']) - 1) * take : 0;

      let selectedParams: Params = {
        ...params,
        take,
        skip,
        page: null,
        perPage: null,
      };

      selectedParams = Object.fromEntries(
        Object.entries(selectedParams).filter(
          ([_, value]) => value != null && value !== ''
        )
      );

      this._projectsService.getAllProjects(selectedParams);
    });
  }
}
